import * as Yup from 'yup';
import { getRequest, putRequest } from '../../services/httpService';

export interface FormValues {
  sample_number: string | null;
  date: string | null;
  time: string | null;

  sperm_type_label: string | null;
  semen_preparation_method_label: string | null;
  sperm_type: string | null;
  semen_preparation_method: string | null;
  gradient_used: string | null;
  gradient_mini_gradient: string | null;

  centrifuged_at_rpm: number | null;
  centrifuged_at_min: number | null;

  swim_up_ml: number | null;
  swim_up_min: number | null;
  wash_media_ml: number | null;
  wash_media_rpm: number | null;
  wash_media_min: number | null;

  remark: string | null;

  collection_or_thaw_date: string | null;
  collection_or_thaw_time: string | null;
  receiving_date: string | null;
  receiving_time: string | null;

  semen_collection_method_label: string | null;
  semen_collection_method: string | null;
  surgical_extraction_type: string | null;
  abstinence_period: string | null;

  cryo_no: string | null;
  thaw_date: string | null;
  thaw_time: string | null;

  sample_collected_at: string | null;
  sample_frozen_at: string | null;

  status?: string | null;

  //Master integration
  PROCESSING_SEMEN_PREPARATION?: string | null;
  PROCESSING_SEMEN_COLLECTION?: string | null;
  PROCESSING_SURGICAL_EXTRACTIONS?: string | null;
  PROCESSING_ABSTINENCES?: string | null;

  SEMEN_PREPARATION?: string | null;
  SEMEN_COLLECTION?: string | null;
  SURGICAL_EXTRACTIONS?: string | null;
  ABSTINENCES?: string | null;

  FREEZING_VISCOSITY?: string | null;
  FREEZING_ABSTINENCES?: string | null;
  FREEZING_SURGICAL_EXTRACTIONS?: string | null;
  FREEZING_SEMEN_COLLECTION?: string | null;
  
  ANALYSIS_COLOR?: string | null;
  ANALYSIS_SEMEN_COLLECTION?: string | null;
  ANALYSIS_ABSTINENCE?: string | null;
  ANALYSIS_SURGICAL_EXTRACTIONS?: string | null;
  ANALYSIS_APPEARANCE?: string | null;
  ANALYSIS_LIQUEFACTION?: string | null;
  ANALYSIS_VISCOSITY?: string | null;
  ANALYSIS_ODOUR?: string | null;
  ANALYSIS_PROGNOSIS?: string | null;
  ANALYSIS_INTERPRETATION?: string | null;

}


export const TypeOfSpermOptions = [
  { value: 'FRESH', label: 'Fresh' },
  { value: 'FROZEN', label: 'Frozen' },
];


export const initialValuesdata: FormValues = {
  sample_number: null,
  date: null,
  time: null,
  sperm_type_label: null,
  sperm_type: null,
  semen_preparation_method_label: null,
  semen_preparation_method: null,
  gradient_used: null,
  gradient_mini_gradient: null,
  centrifuged_at_rpm: null,
  centrifuged_at_min: null,
  swim_up_ml: null,
  swim_up_min: null,
  wash_media_ml: null,
  wash_media_rpm: null,
  wash_media_min: null,
  remark: null,
  collection_or_thaw_date: null,
  collection_or_thaw_time: null,
  receiving_date: null,
  receiving_time: null,
  semen_collection_method_label: null,
  semen_collection_method: null,
  surgical_extraction_type: null,
  abstinence_period: null,
  cryo_no: null,
  thaw_date: null,
  thaw_time: null,
  sample_collected_at: null,
  sample_frozen_at: null
};


export const getSemenProcessingDetailsFields = (sperm_type: string | null) => {
  const baseFields = {
    sample_number: true,
    date: true,
    time: true,
    sperm_type: true,
    semen_preparation_method: true,
  };

  if (sperm_type === 'FRESH') {
    return {
      ...baseFields,
      collection_or_thaw_date: true,
      collection_or_thaw_time: true,
      receiving_date: true,
      receiving_time: true,
      semen_collection_method: true,
      surgical_extraction_type: true,
    };
  }

  return {
    ...baseFields,
    collection_or_thaw_date: false,
    collection_or_thaw_time: false,
    receiving_date: false,
    receiving_time: false,
    semen_collection_method: false,
    surgical_extraction_type: false,
  };
};


export const validationSchema = Yup.object({
  sample_number: Yup.string().required('Sample No. is required'),

  date: Yup.date().required('Preparation Date is required').typeError('Preparation Date must be in YYYY-MM-DD format'),

  time: Yup.string()
    .matches(/^([0-9]{2}):([0-9]{2})$/, 'Preparation Time must be in HH:mm format')
    .required('Preparation Time is required'),
  sperm_type: Yup.string().required('Type of Sperm is required'),
  semen_preparation_method: Yup.string().required('Semen Preparation Method is required'),
  gradient_used: Yup.string(),
  gradient_mini_gradient: Yup.string(),

  centrifuged_at_rpm: Yup.number().integer('RPM must be an integer').nullable(),
  centrifuged_at_min: Yup.number().integer('Centrifuge time must be an integer').nullable(),
  swim_up_ml: Yup.number().typeError('Swim up volume must be a valid number').nullable(),
  swim_up_min: Yup.number().integer('Swim up time must be an integer').nullable(),
  wash_media_ml: Yup.number().typeError('Wash media volume must be a valid number').required('Wash media volume is required'),
  wash_media_rpm: Yup.number().integer('Wash media RPM must be an integer').required('Wash media RPM is required'),
  wash_media_min: Yup.number().integer('Wash media time must be an integer').required('Wash media time (minutes) is required'),

  remark: Yup.string(),

  thaw_date: Yup.string(),
  thaw_time: Yup.string(),

  collection_or_thaw_date: Yup.string()
    .test('is-collection-date-required', 'Collection Date is required for fresh sperm', function (value) {
      const { sperm_type } = this.parent;
      if (sperm_type === 'FRESH' && !value) {
        return this.createError({ message: 'Collection Date is required for fresh sperm' });
      }
      return true;
    })
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Collection Date must be in YYYY-MM-DD format'),

  collection_or_thaw_time: Yup.string()
    .test('is-collection-time-required', 'Collection Time is required for fresh sperm', function (value) {
      const { sperm_type } = this.parent;
      if (sperm_type === 'FRESH' && !value) {
        return this.createError({ message: 'Collection Time is required for fresh sperm' });
      }
      return true;
    })
    .matches(/^([0-9]{2}):([0-9]{2})$/, 'Collection Time must be in HH:mm format'),

  receiving_date: Yup.string()
    .test('is-receiving-date-required', 'Receiving Date is required for fresh sperm', function (value) {
      const { sperm_type } = this.parent;
      if (sperm_type === 'FRESH' && !value) {
        return this.createError({ message: 'Receiving Date is required for fresh sperm' });
      }
      return true;
    })
    .matches(/^\d{4}-\d{2}-\d{2}$/, 'Receiving Date must be in YYYY-MM-DD format'),

  receiving_time: Yup.string()
    .test('is-receiving-time-required', 'Receiving Time is required for fresh sperm', function (value) {
      const { sperm_type } = this.parent;
      if (sperm_type === 'FRESH' && !value) {
        return this.createError({ message: 'Receiving Time is required for fresh sperm' });
      }
      return true;
    })
    .matches(/^([0-9]{2}):([0-9]{2})$/, 'Receiving Time must be in HH:mm format'),

  semen_collection_method: Yup.string()
    .test('is-semen-collection-method-required', 'Semen Collection Method is required for fresh sperm', function (value) {
      const { sperm_type } = this.parent;
      if (sperm_type === 'FRESH' && !value) {
        return this.createError({ message: 'Semen Collection Method is required for fresh sperm' });
      }
      return true;
    }),

  // surgical_extraction_type: Yup.string()
  //   .test('is-surgical-extraction-type-required', 'Surgical Extraction Type is required for fresh sperm', function (value) {
  //     const { sperm_type } = this.parent;
  //     if (sperm_type === 'FRESH' && !value) {
  //       return this.createError({ message: 'Surgical Extraction Type is required for fresh sperm' });
  //     }
  //     return true;
  //   }),
});



export function getputSemenProcessingDetailUrl(id: number): string {
  return `/semen-processing/${id}/details/`;
}
export function getSemenProcessingDetails(patient_id: number): Promise<FormValues> {
  return getRequest(getputSemenProcessingDetailUrl(patient_id));
}


export function putSemenProcessingDetails(patient_id: number, payload: FormValues): Promise<FormValues> {
  return putRequest(getputSemenProcessingDetailUrl(patient_id), payload);
}

export function fetchMasterData(type: string): Promise<FormValues> {
  const url = `clinics/configuration/?module_type=andrology&type=${type}`;
  return getRequest(url, { responseType: 'json' });
}

// Sperm type options array with localization
export const TypeOfSpermOptionsLocalized = [
  { code: 'FRESH', description: { en: 'Fresh', es: 'Fresco', hi: 'ताज़ा', pt: 'Fresco' } },
  { code: 'FROZEN', description: { en: 'Frozen', es: 'Congelado', hi: 'जमा हुआ', pt: 'Congelado' } },
];
